<template>
  <div class="no-service">
    <div class="header"></div>
    <div class="title">服务暂未开通，如需使用，请完成以下两步</div>
    <div class="desc">
      <div class="desc-row hasPoint">
        联系平台运营开通服务
      </div>
      <div class="desc-row hasPoint">
        向网约SP提供企业密钥并获取网约SP运营数据权限
      </div>
      <div class="desc-row">
        <a href="/tenant/linkage/secret/list">校验网约合作商数据共享密钥<i class="QS-icon-arrow-right"></i></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NoService',
}
</script>
<style lang="scss" scoped>
.no-service {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 62px;
}
.header {
  width: 102px;
  height: 67px;
  margin-bottom: 19px;
  background: url('../../../assets/img/box@3x.png') 0 0 no-repeat;
  background-size: 100%;
}
.title {
  margin-bottom: 16px;
  font-size: 12.8px;
  color: #303133;
}
.desc {
  padding-left: 98px;
  font-size: 12.8px;
  color: #606266;
}
.desc-row {
  position: relative;
  margin-bottom: 8px;
  line-height: 18px;
  &.hasPoint::before {
    position: absolute;
    top: 7px;
    left: -12px;
    content: '';
    width: 2px;
    height: 2px;
    border-radius: 5px;
    background: #606266;
  }
}
</style>
